<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <select-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.type.label')"
                    :placeholder="$t('forms.locations.add_location.fields.type.placeholder')"
                    :isRequired="true"
                    :options="locationTypeOptions"
                    valuePath="locationType"
                    @change="change"
                ></select-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.address.label')"
                    :placeholder="$t('forms.locations.add_location.fields.address.placeholder')"
                    :isRequired="true"
                    :isDisabled="isAdressDisabled"
                    type="text"
                    valuePath="address"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <select-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.city.label')"
                    :placeholder="$t('forms.locations.add_location.fields.city.placeholder')"
                    :isDisabled="cityId"
                    :options="cityOptions"
                    valuePath="cityId"
                    :isSearchable="true"
                    @change="change"
                    @clear="clear"
                ></select-input>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.country.label')"
                    :placeholder="$t('forms.locations.add_location.fields.country.placeholder')"
                    :isDisabled="true"
                    type="text"
                    valuePath="country"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row v-if="data?.locationType === LocationTypeEnum.BUSINESS">
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.phone.label')"
                    :placeholder="$t('forms.locations.add_location.fields.phone.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="telephones.0.telephone"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row v-if="data?.locationType === LocationTypeEnum.BUSINESS">
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.locations.add_location.fields.email.label')"
                    :placeholder="$t('forms.locations.add_location.fields.email.placeholder')"
                    type="text"
                    valuePath="emails.0.email"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>

        <form-row v-if="data?.locationType === LocationTypeEnum.BUSINESS && isCompany">
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.profile.fields.google.label')"
                    :placeholder="$t('forms.user.profile.fields.google.placeholder')"
                    :isDisabled="isDisabled"
                    type="text"
                    valuePath="googleBusiness"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <template #footer>
            <common-buttons>
                <common-button
                    type="secondary"
                    :isSubmittable="false"
                    :isProcessing="isSubmittingForm"
                    :label="$t('common.microcopy.back')"
                    @click="emitEvent({ name: 'search-again' })"
                ></common-button>
                <common-button
                    type="primary"
                    :isProcessing="isSubmittingForm"
                    :label="$t('common.microcopy.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import LocationsAPI from 'api/LocationsAPI'
    import LocationTypeEnum from 'enums/location_type.enum'

    export default {
        mixins: [FormMixin],

        props: {
            prefill: { type: Object, default: undefined },
            cityOptions: { type: Array, required: true },
            isSubmittingForm: { type: Boolean, default: false },
            isCompany: { type: Boolean, default: false },
        },

        data: () => ({
            cityId: undefined,
            LocationTypeEnum: LocationTypeEnum,
        }),

        computed: {
            isAdressDisabled() {
                return this.prefill.address
            },

            locationTypeOptions() {
                return Object.values(LocationTypeEnum).map((item) => {
                    return {
                        value: item,
                        label: this.$t(`forms.locations.add_location.${item.toLowerCase()}`),
                    }
                })
            },
        },

        methods: {
            submit() {
                this.cityId = this.data.cityId
                const coordinates = this.prefill.coordinates
                const request = {
                    address: this.data.address,
                    location: `POINT(${coordinates.lng} ${coordinates.lat})`,
                    cityId: Number(!isNaN(this.data.cityId) ? this.data.cityId : undefined),
                    telephones: [{ telephone: this.data['telephones.0.telephone'] }],
                    emails: [{ email: this.data['emails.0.email'] }],
                    googleBusiness: this.data.googleBusiness,
                    locationType: this.data.locationType,
                }

                if (this.isCompany) {
                    request.companyId = this.$route.params.id
                    LocationsAPI.createLocationForCompany(request).then((location) => {
                        this.$auth.reloadUser()
                        this.emitEvent({ name: 'add-location', payload: location })
                    })
                } else {
                    LocationsAPI.createLocationForUser(request).then((location) => {
                        this.$auth.reloadUser()
                        this.emitEvent({ name: 'add-location', payload: location })
                    })
                }
            },

            prefillFormData() {
                const prefill = {
                    address: this.prefill.address,
                    country: this.prefill.country,
                }
                if (this.prefill?.city) {
                    prefill.cityId = this.cityOptions.find(
                        (city) => city.label.toLowerCase() === this.prefill.city.toLowerCase(),
                    )?.value
                    this.cityId = prefill.cityId
                }
                if (this.prefill) {
                    this.prefillData(prefill)
                }
            },
        },

        mounted() {
            this.data.locationType = LocationTypeEnum.BUSINESS
            this.prefillFormData()
        },
    }
</script>
